import usePermissions from "hooks/usePermissions";
import { COLLECTOR_PERMISSIONS, scoped } from "../Permissions";
import { COLLECTOR_SYSTEM_LOGS_STREAM_ID } from "../common/fields";
const COLLECTOR_INGEST_INPUT_TYPE = "org.graylog.collectors.input.CollectorIngestHttpInput";
const useCollectorPermissions = () => {
  const { isPermitted } = usePermissions();
  return {
    canCreateFleet: isPermitted(COLLECTOR_PERMISSIONS.FLEET_CREATE),
    canEditFleet: (fleetId) => isPermitted(scoped(COLLECTOR_PERMISSIONS.FLEET_EDIT, fleetId)),
    canDeleteFleet: (fleetId) => isPermitted(scoped(COLLECTOR_PERMISSIONS.FLEET_DELETE, fleetId)),
    canCreateSource: (fleetId) => isPermitted(scoped(COLLECTOR_PERMISSIONS.SOURCE_CREATE, fleetId)),
    canEditSource: (fleetId) => isPermitted(scoped(COLLECTOR_PERMISSIONS.SOURCE_EDIT, fleetId)),
    canDeleteSource: (fleetId) => isPermitted(scoped(COLLECTOR_PERMISSIONS.SOURCE_DELETE, fleetId)),
    canDeleteInstance: (fleetId) => isPermitted(scoped(COLLECTOR_PERMISSIONS.FLEET_INSTANCE_DELETE, fleetId)),
    // The backend checks BOTH on the target fleet (CollectorInstancesResource:347-348).
    canAssignToFleet: (fleetId) => isPermitted([
      scoped(COLLECTOR_PERMISSIONS.FLEET_READ, fleetId),
      scoped(COLLECTOR_PERMISSIONS.FLEET_INSTANCE_ASSIGN, fleetId)
    ]),
    canCreateToken: (fleetId) => isPermitted(scoped(COLLECTOR_PERMISSIONS.ENROLL_TOKEN_CREATE, fleetId)),
    canDeleteToken: (fleetId) => isPermitted(scoped(COLLECTOR_PERMISSIONS.ENROLL_TOKEN_DELETE, fleetId)),
    // Page- and tab-level gates. Unlike the checks above these are unscoped, because a page has no
    // single fleet in context — the scoped variants still gate the individual controls inside it.
    // Consequence: a user holding only a fleet-scoped grant would not match here. That mirrors the
    // existing top-level Collectors nav gate, and is unreachable today (fleets are not shareable).
    canDeployCollectors: isPermitted(COLLECTOR_PERMISSIONS.ENROLL_TOKEN_CREATE),
    canViewEnrollmentTokens: isPermitted(COLLECTOR_PERMISSIONS.ENROLL_TOKEN_READ),
    // Collector self-logs are routed to a built-in stream, so the links into search are gated by a
    // STREAM permission rather than a collector one. Without it the link lands on the "Missing
    // Stream Permissions" page, so we know enough not to offer it.
    canReadSystemLogs: isPermitted(scoped("streams:read", COLLECTOR_SYSTEM_LOGS_STREAM_ID)),
    canReadActivities: isPermitted(COLLECTOR_PERMISSIONS.ACTIVITIES_READ),
    canEditConfig: isPermitted(COLLECTOR_PERMISSIONS.CONFIGURATION_EDIT),
    // The ingest input is a regular input, so these are INPUT permissions (same checks the inputs page and
    // CollectorIngestInputService apply). Notably absent from the built-in Collectors Manager role.
    canCreateIngestInput: isPermitted(["inputs:create", scoped("input_types:create", COLLECTOR_INGEST_INPUT_TYPE)]),
    canEditIngestInput: (inputId) => isPermitted([scoped("inputs:edit", inputId), scoped("input_types:create", COLLECTOR_INGEST_INPUT_TYPE)])
  };
};
export default useCollectorPermissions;
